module.exports = __webpack_public_path__ + "img/kl_hszz.2efa524d.png";